import { useState, useCallback } from 'react'

// Manages which Ad Library modal is open and its payload.
// type: 'createFolder' | 'uploadAd' | 'renameAd' | 'renameFolder'
//       | 'deleteAds' | 'deleteFolder' | 'previewAd' | null
// payload carries the target, e.g. { ids: [...] } or { ad } or { folder }.
const useAdLibraryModals = () => {
  const [modal, setModal] = useState(null)
  const [payload, setPayload] = useState(null)

  const open = useCallback((type, data = null) => {
    setModal(type)
    setPayload(data)
  }, [])

  const close = useCallback(() => {
    setModal(null)
    setPayload(null)
  }, [])

  return { modal, payload, open, close }
}

export default useAdLibraryModals
